function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12m2.528-17.384a1.04 1.04 0 0 0-.527-.926 1.05 1.05 0 0 0-.543-.145q-.466 0-.777.32a1.04 1.04 0 0 0-.31.75q0 .449.31.769.312.32.777.32.431 0 .75-.32.32-.321.32-.768m-.614 8.392h-.764q-.398.713-.664.98-.265.265-.514.265-.092 0-.17-.096a.3.3 0 0 1-.08-.195q0-.224.133-.58l1.295-3.479q.183-.48.183-.954a.85.85 0 0 0-.361-.718q-.36-.27-.909-.27-.78 0-1.565.602T9.224 12.26h.73a4.6 4.6 0 0 1 .503-.788q.336-.44.618-.44a.23.23 0 0 1 .166.074.23.23 0 0 1 .075.166q0 .142-.158.54l-1.07 2.93q-.308.855-.308 1.337 0 .473.349.817.348.345 1.046.345 1.038 0 1.726-.756.69-.755 1.013-1.477",
    style: {
      fill: "var(--color-action-active)"
    }
  }));
};
export default SvgInfo;